module.exports = __webpack_public_path__ + "img/tertiary_10x4_z16.3c780caf.svg";